export const siteInfo = {
  name: '暗网51',
  tagline: '深度解析与安全防护指南',
  description: '暗网51是专注于暗网生态深度解析的权威资讯平台，涵盖暗网安全威胁、隐私防护、网络安全知识与最新动态，帮助用户了解暗网风险、掌握自我防护技能，守护个人数据与网络安全。',
  founded: '2023',
  email: 'contact@darkweb51.com',
  address: '中国北京市海淀区中关村科技园区',
};

export const reputationItems = [
  {
    id: 1,
    name: '国家互联网应急中心',
    title: '推荐合作伙伴',
    content: '暗网51作为国内领先的网络安全资讯平台，在暗网威胁情报分析和公众安全意识教育方面做出了重要贡献。其发布的安全报告多次被国家级安全机构引用，专业性和权威性得到业界广泛认可。',
  },
  {
    id: 2,
    name: '中国网络安全产业联盟',
    title: '优秀成员单位',
    content: '暗网51凭借其对暗网生态的深度研究和高质量的安全科普内容，在网络安全社区建立了良好的声誉。平台秉持客观、专业的原则，为广大网民提供了可靠的安全知识和实用的防护建议。',
  },
  {
    id: 3,
    name: '信息安全国家重点实验室',
    title: '学术合作伙伴',
    content: '暗网51的研究团队在暗网数据采集与分析方面展现了卓越的技术能力。我们与暗网51在多项研究课题上建立了深度合作，共同推进网络安全威胁情报的学术研究与实践应用。',
  },
  {
    id: 4,
    name: '赵明远',
    title: '资深安全架构师',
    content: '暗网51是我日常必读的安全资讯平台。他们的文章不仅覆盖最新的安全事件，更重要的是能够从技术和管理两个维度提供深度的分析视角。对于一线安全从业者来说，这是难得的信息来源。',
  },
  {
    id: 5,
    name: '王晓琳',
    title: '企业信息安全总监',
    content: '我向团队推荐暗网51已经两年了。他们的暗网风险分析报告帮助我们的安全团队及时了解新的威胁趋势，在多次安全事件预防中发挥了关键作用。内容的深度和专业性远超同类平台。',
  },
  {
    id: 6,
    name: '陈建国',
    title: '网络安全教育工作者',
    content: '暗网51的科普内容非常适合作为教学参考材料。他们把复杂的安全概念用通俗易懂的语言表达出来，又不失专业性。我经常推荐我的学生关注这个平台来拓展视野。',
  },
];

export const faqItems = [
  {
    question: '什么是暗网？暗网51如何帮助我了解暗网？',
    answer: '暗网（Dark Web）是互联网生态中的特殊组成部分，需要通过Tor等特殊工具访问。暗网51通过深度研究、专家分析和实时追踪，将暗网中的安全威胁、风险趋势和防护知识以通俗易懂的方式呈现给您，帮助您在不直接接触暗网的情况下了解其中的风险，从而更好地保护自己和组织的网络安全。',
  },
  {
    question: '暗网51的内容是否涉及非法信息？',
    answer: '不涉及。暗网51严格遵守中华人民共和国法律法规，所有内容均为网络安全教育、威胁分析和防护指南。我们不会发布任何可能助长违法活动的具体操作指导，也不会展示任何非法内容。我们的使命是教育公众，提升全社会的网络安全意识。',
  },
  {
    question: '普通人需要关注暗网安全吗？',
    answer: '非常需要。虽然您可能从未访问过暗网，但您泄露的个人数据很可能正在暗网上被交易。身份信息、银行卡号、邮箱密码——这些数据一旦泄露，就会被在暗网上转卖。了解暗网的安全威胁，可以帮助您更好地保护自己的个人信息和数字资产。',
  },
  {
    question: '如何订阅暗网51的最新内容？',
    answer: '您可以通过本站的新闻通讯订阅功能获取最新的安全资讯。我们每周会发送精选的安全动态、深度分析和防护建议到您的邮箱。此外，您也可以将本站加入浏览器收藏夹，随时访问获取最新内容。',
  },
  {
    question: '暗网51的文章是否免费阅读？',
    answer: '是的，暗网51目前所有内容均免费开放阅读。我们相信网络安全知识的普及不应该有门槛。未来我们可能会推出深度研究报告等增值服务，但基础的安全科普内容将继续保持免费。',
  },
];

export const contactInfo = {
  email: 'contact@darkweb51.com',
  wechat: 'DarkWeb51',
  phone: '400-888-5100',
  address: '中国北京市海淀区中关村科技园区',
  workingHours: '周一至周五 9:00 - 18:00',
};